/* eslint-disable import/prefer-default-export */
export const VENDOR_PREFERENCE = 'VENDOR_PREFERENCE';
export const SETTINGS = 'SETTINGS';
export const STORE_INPUTS = 'STORE_INPUTS';
export const PAYMENT_SETTINGS = 'PAYMENT_SETTINGS';
export const PAYMENT_INPUT = 'PAYMENT_INPUT';
export const UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD';
export const PAYMENT_LOADER = 'PAYMENT_LOADER';
